var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C99 0 198 0 300 0 C300 14.52 300 29.04 300 44 C201 44 102 44 0 44 C0 29.48 0 14.96 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(106,234)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C99 0 198 0 300 0 C300 14.19 300 28.38 300 43 C201 43 102 43 0 43 C0 28.81 0 14.62 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(106,320)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C99 0 198 0 300 0 C300 14.19 300 28.38 300 43 C201 43 102 43 0 43 C0 28.81 0 14.62 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(106,149)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleMenuIcon);
export default __webpack_public_path__ + "static/media/toggleMenu-Icon.2a8d5097283addb9775551b3840b3dcc.svg";
export { ForwardRef as ReactComponent };